/**
 *
 * Asynchronously loads the component for EventGroupPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
